/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

import {
  BLACK,
  BLUE_FEEK,
  PURPLE_FEEK,
  GRAY_LIGHTER,
} from 'styles/colors';
import Text from 'components/Text';
import FeekSubeContenido from 'assets/images/FeekSubeContenido.png';
import FeekDescubreAgenda from 'assets/images/FeekDescubreAgenda.png';
import FeekValidaDisfruta from 'assets/images/FeekValidaDisfruta.png';
import FeekIconSubeContenido from 'assets/images/FeekIconSubeContenido.png';
import FeekIconDescubreAgenda from 'assets/images/FeekIconDescubreAgenda.png';
import FeekIconGanaFeekpoints from 'assets/images/FeekIconGanaFeekpoints.png';
import FeekIconValidaDisfruta from 'assets/images/FeekIconValidaDisfruta.png';

const styles = css`
  .features {
    padding: 120px 50px 60px 70px;
    border-radius: 30px;
    border-top: 2px solid ${GRAY_LIGHTER};
    max-width: 100%;
    margin: 0 auto;
  }

  .features .title {
    padding-left: 60px;
  }

  .features-info {
    max-width: 100%;
    background: #efeeff;
    display: flex;
    padding: 0 100px;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .features-info-title {
    color: var(--Brand-Blue-Feek, ${BLUE_FEEK});
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 46px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    padding-bottom: 15px;
  }

  .features-info-text {
    color: var(--ui-20-black-out, #000);
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    justify-content: center;
    padding-bottom: 30px;
  }

  .features-card {
    width: 100%;
    min-height: 540px;
    border-radius: 24px;
    border: 1px solid #e7e3ff;
    background: var(--ui-20-light-purple, #efeeff);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .features-card-bottom {
    width: 100%;
    min-height: 350px;
    border-radius: 24px;
    border: 1px solid #e7e3ff;
    background: var(--ui-20-light-purple, #efeeff);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .main-card {
    padding: 45px;
    flex: 1;
  }

  .main-card-icon {
    display: flex;
    width: 50px;
    height: 50px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-bottom: 15px;
  }

  .main-card-title {
    leading-trim: both;
    text-edge: cap;
    padding-bottom: 15px;
    font-family: Roobert;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
  }

  .margin-title {
    margin-top: 15px;
  }

  .main-card-text {
    leading-trim: both;
    text-edge: cap;
    font-family: Roobert;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
  }

  .main-card-image {
    width: 100%;
    max-width: 450px;
    margin-top: -50px;
    object-fit: contain;
    aspect-ratio: 5/7;
  }

  .main-card-image-2 {
    width: calc(min(100vw * 0.4, 800px));
    max-width: 800px;
    min-width: 600px;
    position: absolute;
    right: 0;
    z-index: 2;
    object-fit: contain;
    height: auto;
  }

  .main-card-image-3 {
    width: 100%;
    max-width: 350px;
    margin-bottom: -100px;
    object-fit: contain;
    aspect-ratio: 5/6;
  }

  .features-card-xtra article {
    min-height: 600px;
  }

  /* Responsive Design */
  @media (max-width: 1200px) {
    .features {
      padding: 100px 15px 50px 15px;
    }

    .features .title {
      padding-left: 30px;
    }

    .features-info {
      padding: 0 50px;
    }

    .features-info-title {
      font-size: 38px;
    }

    .features-info-text {
      font-size: 18px;
    }

    .main-card {
      padding: 30px;
    }

    .main-card-image {
      max-width: 350px;
    }

    .main-card-image-2 {
      width: calc(min(100vw * 0.35, 750px));
      max-width: 750px;
      min-width: 550px;
      position: absolute;
      right: 0;
      height: auto;
    }

    .main-card-image-3 {
      max-width: 300px;
    }
  }

  @media (max-width: 992px) {
    .features {
      padding: 80px 10px 40px 10px;
    }

    .features .title {
      padding-left: 20px;
    }

    .features-info {
      padding: 0 30px;
    }

    .features-info-title {
      font-size: 32px;
    }

    .features-info-text {
      font-size: 16px;
    }

    .features-card,
    .features-card-bottom {
      min-height: 450px;
    }

    .main-card {
      padding: 25px;
    }

    .main-card-image {
      max-width: 300px;
      margin-top: -40px;
    }

    .main-card-image-2 {
      width: calc(min(100vw * 0.3, 700px));
      max-width: 700px;
      min-width: 500px;
      position: absolute;
      right: 0;
      height: auto;
    }

    .main-card-image-3 {
      max-width: 250px;
      margin-bottom: -60px;
    }
  }

  @media (max-width: 768px) {
    .features {
      padding: 60px 5px 30px 5px;
    }

    .features .title {
      padding-left: 10px;
    }

    .features-info {
      padding: 0 20px;
    }

    .features-info-title {
      font-size: 28px;
    }

    .features-info-text {
      font-size: 14px;
    }

    .features-card,
    .features-card-bottom {
      min-height: 400px;
      margin-bottom: 20px;
    }

    .main-card {
      padding: 20px;
    }

    .main-card-title {
      font-size: 24px;
    }

    .main-card-text {
      font-size: 16px;
    }

    .main-card-image {
      max-width: 250px;
      margin-top: -30px;
    }

    .main-card-image-2 {
      width: calc(min(100vw * 0.25, 650px));
      max-width: 650px;
      min-width: 450px;
      position: absolute;
      right: 0;
      height: auto;
    }

    .main-card-image-3 {
      max-width: 200px;
      margin-bottom: -40px;
    }
  }

  @media (max-width: 576px) {
    .features {
      padding: 40px 5px 20px 5px;
    }

    .features-info {
      padding: 0 15px;
    }

    .features-info-title {
      font-size: 24px;
    }

    .features-info-text {
      font-size: 12px;
    }

    .features-card,
    .features-card-bottom {
      min-height: 350px;
      margin-bottom: 15px;
    }

    .main-card {
      padding: 15px;
    }

    .main-card-title {
      font-size: 20px;
    }

    .main-card-text {
      font-size: 14px;
    }

    .main-card-icon {
      width: 40px;
      height: 40px;
    }

    .main-card-image {
      max-width: 200px;
      margin-top: 85px;
    }

    .main-card-image-2 {
      width: calc(min(100vw * 0.2, 600px));
      max-width: 600px;
      min-width: 400px;
      position: absolute;
      right: 0;
      height: auto;
    }

    .main-card-image-3 {
      max-width: 150px;
      margin-bottom: -30px;
    }
    .row {
      margin-left: auto;
      margin-right: auto;
    }
  }
`;

/**
 * FeatureCard component - displays a feature card with icon, title, description and image
 */
const FeatureCard = ({
  icon,
  title,
  description,
  image,
  imageClass,
  isBottom = false,
  isFull = false,
  titleClass = '',
}) => {
  const cardClass = isBottom
    ? 'features-card-bottom'
    : 'features-card';

  const cardRowClass = isFull
    ? 'col-12 main-card'
    : 'col-xl-5 col-lg-5 col-md-6 col-sm-12 main-card';

  const cardRowLastClass = isFull
    ? 'col-12 col-lg-12 col-md-12 col-sm-12'
    : 'col-7 col-lg-7 col-md-6 col-sm-12 d-flex align-items-center justify-content-center';

  return (
    <article className={cardClass}>
      <div className="row w-100 h-100">
        <div className={cardRowClass}>
          <picture>
            <img
              src={icon}
              alt={`${title} icon`}
              className={`main-card-icon ${titleClass}`}
              loading="lazy"
            />
          </picture>
          <Text
            color={PURPLE_FEEK}
            fontSize={25}
            className="main-card-title"
          >
            {title}
          </Text>
          <Text
            color={BLACK}
            fontSize={18}
            className="main-card-text"
          >
            {description}
          </Text>
        </div>
        <div className={cardRowLastClass}>
          <img
            src={image}
            alt={`${title} illustration`}
            className={imageClass}
            loading="lazy"
          />
        </div>
      </div>
    </article>
  );
};

FeatureCard.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string.isRequired,
  isBottom: PropTypes.bool,
  isFull: PropTypes.bool,
  titleClass: PropTypes.string,
};

/**
 * FeatureCardBottom component - displays a bottom-aligned feature card
 */
const FeatureCardBottom = ({
  icon,
  title,
  description,
  image,
  imageClass,
}) => {
  return (
    <article className="features-card-bottom">
      <div className="row w-100 h-100">
        <div className="col-xl-5 col-lg-5 col-md-6 col-sm-12 main-card">
          <picture>
            <img
              src={icon}
              alt={`${title} icon`}
              className="main-card-icon"
              loading="lazy"
            />
          </picture>
          <Text
            color={PURPLE_FEEK}
            fontSize={25}
            className="main-card-title"
          >
            {title}
          </Text>
          <Text
            color={BLACK}
            fontSize={18}
            className="main-card-text"
          >
            {description}
          </Text>
        </div>
        <div className="col-xl-7 col-lg-7 col-md-6 col-sm-12 d-flex align-items-end justify-content-center">
          <img
            src={image}
            alt={`${title} illustration`}
            className={imageClass}
            loading="lazy"
          />
        </div>
      </div>
    </article>
  );
};

FeatureCardBottom.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  imageClass: PropTypes.string.isRequired,
};

/**
 * FeekFeatures component - displays the main features of Feek in a grid layout
 * Shows the user journey: Discover & Book → Upload Content → Validate & Enjoy → Earn Points
 */
/**
 * FeekFeatures component - displays the main features of Feek in a grid layout
 * Shows the user journey: Discover & Book → Upload Content → Validate & Enjoy → Earn Points
 */
export const FeekFeatures = () => {
  return (
    <section css={styles} aria-labelledby="features-title">
      {/* SEO heading - positioned off-screen to avoid layout shift */}
      <h2
        id="features-title"
        style={{
          position: 'absolute',
          left: '-9999px',
          width: '1px',
          height: '1px',
          overflow: 'hidden',
          clip: 'rect(0, 0, 0, 0)',
        }}
        aria-hidden="true"
      >
        Características principales de Feek
      </h2>
      <div className="features mb80">
        <div className="row w-100">
          {/* First Row */}
          <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 d-flex justify-content-center align-items-center mb-4 mb-md-5">
            <FeatureCard
              icon={FeekIconGanaFeekpoints}
              title="Descubre y Agenda"
              description="Encuentra tus negocios favoritos, agenda en la app y obtén beneficios exclusivos."
              image={FeekDescubreAgenda}
              imageClass="main-card-image"
              titleClass="margin-title"
            />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 d-flex justify-content-center align-items-center features-card-xtra mb-4 mb-md-5">
            <FeatureCard
              icon={FeekIconValidaDisfruta}
              title="Sube contenido"
              description="Asiste al lugar que agendaste, disfruta y comparte tu experiencia en Instagram etiquetando al negocio."
              image={FeekSubeContenido}
              imageClass="main-card-image-2"
              isFull={true}
              className=""
            />
          </div>

          {/* Second Row */}
          <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12 d-flex justify-content-center align-items-center mb-4 mb-md-5">
            <FeatureCardBottom
              icon={FeekIconSubeContenido}
              title="Valida y Disfruta"
              description="Valida la promoción en tu agenda mediante tus historias de Instagram y listo!."
              image={FeekValidaDisfruta}
              imageClass="main-card-image-3"
            />
          </div>
          <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 d-flex justify-content-center align-items-center mb-4 mb-md-5">
            <div className="features-card-bottom">
              <div className="row w-100 h-100">
                <div className="col-12 main-card d-flex flex-column justify-content-center">
                  <picture>
                    <img
                      alt="Gana Recompensas icon"
                      className="main-card-icon"
                      src={FeekIconDescubreAgenda}
                      loading="lazy"
                    />
                  </picture>
                  <Text
                    color={PURPLE_FEEK}
                    fontSize={25}
                    className="main-card-title"
                  >
                    Gana Recompensas
                  </Text>
                  <Text
                    color={BLACK}
                    fontSize={18}
                    className="main-card-text"
                  >
                    Participa para ganar recompensas increíbles al
                    completar tus campañas.
                  </Text>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
